// @flow

import React, { type Node } from 'react';

export function ErrorMessage({ children }: ErrorMessageProps): Node {
  return (
    <p className="field__message field__message--error field__error--visible" style={{ display: 'block' }}>
      {children}
    </p>
  );
}

type ErrorMessageProps = {
  +children: Node,
};
